export default __webpack_public_path__ + "static/media/Board_Evaluation_Policy_2.04185819.pdf";